export const SAMPLE_POSTER_SRC = "/media/sample-poster.png";
export const SAMPLE_VIDEO_SRC = "/media/sample.mp4";
